module.exports = __webpack_public_path__ + "img/logo.577db6df.png";